import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { UserAuthForm } from "@/components/ui/user-auth-form";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (data: { email: string; password: string }) => {
    try {
      await login(data.email, data.password);
      navigate("/dashboard");
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Ein unbekannter Fehler ist aufgetreten.");
      }
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* Left side - illustration */}
      <div className="hidden lg:flex flex-1 bg-primary items-center justify-center p-8">
        <div className="max-w-md text-white">
          <h1 className="text-3xl font-bold mb-6">LeadsPro - Ihr Lead Management System</h1>
          <p className="text-lg mb-4">
            Willkommen zurück! Melden Sie sich an, um Ihre Leads zu verwalten und Ihren Vertriebserfolg zu steigern.
          </p>
          <ul className="space-y-2 mb-6">
            <li className="flex items-center">
              <div className="rounded-full bg-white/20 p-1 mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              Lead-Management mit Kanban-Board
            </li>
            <li className="flex items-center">
              <div className="rounded-full bg-white/20 p-1 mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              Umfassende Kontakthistorie
            </li>
            <li className="flex items-center">
              <div className="rounded-full bg-white/20 p-1 mr-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              Erinnerungssystem für Termine
            </li>
          </ul>
        </div>
      </div>

      {/* Right side - login form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md space-y-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold">Anmelden</h2>
            <p className="text-muted-foreground mt-2">
              Bitte melden Sie sich mit Ihren Zugangsdaten an
            </p>
          </div>

          {error && (
            <div className="bg-destructive/15 text-destructive px-4 py-3 rounded-md text-sm mb-4">
              {error}
            </div>
          )}

          <UserAuthForm type="login" onSubmit={handleLogin} />

          <div className="text-center mt-4">
            <p className="text-sm text-muted-foreground">
              Noch kein Konto?{" "}
              <Link to="/register" className="text-primary hover:underline font-medium">
                Jetzt registrieren
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
